import { render, staticRenderFns } from "./organizationInfo.vue?vue&type=template&id=5c47711c&scoped=true"
import script from "./organizationInfo.vue?vue&type=script&lang=js"
export * from "./organizationInfo.vue?vue&type=script&lang=js"
import style0 from "./organizationInfo.vue?vue&type=style&index=0&id=5c47711c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c47711c",
  null
  
)

export default component.exports